class ImageSlider extends HTMLElement {
  connectedCallback() {
    customElements.whenDefined('slideshow-component').then(() => {
      const slideshow = this.querySelector('slideshow-component');
      if (!slideshow) return;

      slideshow.next = function(event, options) {
        event?.preventDefault();
        this.select(this.current + 1, event, options);
      };

      slideshow.previous = function(event, options) {
        event?.preventDefault();
        this.select(this.current - 1, event, options);
      };
    });
  }
}

if (!customElements.get('image-slider')) {
  customElements.define('image-slider', ImageSlider);
}
